import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { VLazyImagePlugin } from "v-lazy-image"
import Vue2TouchEvents from 'vue2-touch-events'
import VueMeta from 'vue-meta'
import 'url-search-params-polyfill';

Vue.config.productionTip = false
Vue.use(VLazyImagePlugin);
Vue.use(Vue2TouchEvents);
Vue.use(VueMeta);
require('intersection-observer');


window.vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
